import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-file
import React from 'react';
import Dropdown from '../../../../../vendor/react-dropdown/index';
import "./SelectDropdown.scss";
export const SelectDropdown = function SelectDropdown({ propName, value, values, onChange, onPreview, maxHeight, withSearch }) {
    return _jsx("div", { className: "canva-props-panel-select-dropdown-root", children: _jsx(Dropdown, { className: "canva-props-panel-select-dropdown-input", options: values, maxHeight: maxHeight, withSearch: withSearch, onHoverStart: (value) => onPreview(propName, value.value), onHoverEnd: (value) => onPreview(propName, value.value), onChange: (value) => onChange(propName, value.value), value: value }) });
};
